import { c as _c } from "react/compiler-runtime";
import type { PaginatedRequestResponse } from '@onefootprint/request';
import request from '@onefootprint/request';
import type { AuditEvent } from '@onefootprint/request-types/dashboard';
import { useInfiniteQuery } from '@tanstack/react-query';
import type { AuthHeaders } from '@/hooks/use-session';
import useSession from '@/hooks/use-session';
import useSecurityLogsQueryParams from './use-security-logs-filters';
export type GetAccessEventsRequest = {
  cursor?: string;
  search?: string;
  targets?: string[];
  timestamp_gte?: string; // from
  timestamp_lte?: string; // to
  page_size?: number;
};
export type GetAccessEventsResponse = AuditEvent[];
const getAccessEventsRequest = async (params: GetAccessEventsRequest, authHeaders: AuthHeaders) => {
  const response = await request<PaginatedRequestResponse<GetAccessEventsResponse>>({
    headers: authHeaders,
    method: 'GET',
    params: {
      ...params,
      page_size: 100
    },
    url: '/org/audit_events'
  });
  return response.data;
};
const useGetAccessEvents = () => {
  const $ = _c(8);
  const {
    authHeaders
  } = useSession();
  const queryParams = useSecurityLogsQueryParams();
  let t0;
  let t1;
  if ($[0] !== authHeaders || $[1] !== queryParams.requestParams) {
    t0 = ["accessEvents", queryParams.requestParams, authHeaders];
    t1 = t2 => {
      const {
        pageParam
      } = t2;
      return getAccessEventsRequest({
        ...queryParams.requestParams,
        cursor: pageParam
      }, authHeaders);
    };
    $[0] = authHeaders;
    $[1] = queryParams.requestParams;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  let t2;
  if ($[4] !== queryParams.isReady || $[5] !== t0 || $[6] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      getNextPageParam: _temp,
      initialPageParam: undefined as undefined | string,
      enabled: queryParams.isReady
    };
    $[4] = queryParams.isReady;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export default useGetAccessEvents;
function _temp(lastPage) {
  return lastPage.meta.next;
}